import { render, staticRenderFns } from "./quotaAllocationModal.vue?vue&type=template&id=48725f3a&scoped=true"
import script from "./quotaAllocationModal.vue?vue&type=script&lang=js"
export * from "./quotaAllocationModal.vue?vue&type=script&lang=js"
import style0 from "./quotaAllocationModal.vue?vue&type=style&index=0&id=48725f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48725f3a",
  null
  
)

export default component.exports